import DayScreenThemes from './theme/DayScreenTheme';

export default {
  Lexus: {
    Day: { ...DayScreenThemes },
  },
};
